import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import * as moment from "moment";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";

import Card from '@material-ui/core/Card';




class MailDetailPage extends Component {

  protected event: EventInterface;
  protected charge: ChargeInterface;
  protected tenant: PersonInterface;
  protected contract: ContractInterface;
  protected unit: UnitInterface;
  protected property: UnitInterface;

  // protected shouldClearBeforeUnmounting: boolean = true;
  // protected clearWith: string = Constants.PAGE_EVENT_UPDATE_CLEAR;

  protected middlewares: MiddlewareInterface[] = [
    // PreventPageLeave
  ];

  constructor(public props) {
    super(props);
    let ids = this.props.location.pathname.split(/\D+/g);

    if(ids && ids[1]) {
      this.props.dispatch({
        type: Constants.PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_START,
        payload: {
          emailAccount: ids[1]
        }
      });
    }
  }



  public render() {

    let ids = this.props.location.pathname.split(/\D+/g);
    let mailContent;
    if(this.props.mails.emails) {
      let mail = this.props.mails.emails.filter( event => {
        return event.id === +ids[2];
      });
      mailContent = mail[0];
    } else {
      mailContent = {content: {letter:{date:'',from:[{address:'', name:''}]}}}
    }

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="back-arrow-wrapper" onClick={this.redirectBack}>
              <div className="icon icon-ic-arrow-back icon-color"></div>
            </div>
            <h1>{this.trans("mail-page-detail-title")}</h1>
          </div>
          <div className="box component-mail-update">
              <div className="component-wrapper no-margin-top">
                <div className="component">
                  <Card className="card">
                    <div className="label-container no-borders has-icon">
                      <h3 className="card-title" style={{display: "inline-flex"}}>
                        <div className="icon icon-ic-email" style={{marginRight: "15px"}}></div>
                        <span className="mail-name">{mailContent.content.letter.from[0].name}</span>
                        <span className="mail-address">{'<'}{mailContent.content.letter.from[0].address}{'>'}</span>
                      </h3>
                    </div>
                    <div className="mail-timeline">
                    {moment(mailContent.content.letter.date).format('L, h:mm:ss a')}
                    </div>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "0 20px 20px 20px"}}>
                      <p className='text-email' style={{color: "#404040", fontSize: "14px", margin: "0px", }}>
                        {mailContent.content.letter.text}
                      </p>
                    </div>
                  </Card>
                </div>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.notificationUpdate,
    mails: state.mails,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  MailDetailPage
);
